<template>
	<div class="layout-topbar">

		<button class="p-link layout-menu-button" @click="$emit('menu-toggle', $event)">
			<span class="pi pi-bars"></span>
		</button>
		
		<div class="layout-topbar-title">
			<span class="title"> {{titleOrigin}} <span class="pi pi-chevron-right"/> {{title}} </span>
		</div>
		
		<div class="layout-topbar-icons">
			<span class="username">{{ logonUserInfo }}</span>
			<span style="padding-left: 1rem">[{{activeprofile}}]</span>

			<button class="p-link" @click="btnAct('MYINFO')">
				<span class="layout-topbar-item-text">개인정보변경</span>
				<router-link to="/AccountPage">
				</router-link>
			</button>
			<button class="p-link" @click="btnAct('PASSWORD')">
				<span class="layout-topbar-item-text">암호변경</span>
				<router-link to="/PasswordPage">
				</router-link>
			</button>
			<button class="p-link" @click="btnAct('LOGOUT')">
				<span class="layout-topbar-item-text">로그아웃</span>
			</button>
		</div>
	</div>
</template>

<script>
import {  ref } from '@vue/reactivity';
//import { onMounted, watch } from '@vue/runtime-core';
import { onMounted, computed, watch } from 'vue';
import { useRouter, useRoute } from 'vue-router';
import { useStore } from 'vuex';
import { useToast } from 'primevue/usetoast';
import AuthService from '@/service/AuthService';
import SystemService from '@/service/SystemService';

export default {
	props: {
			pageTitle: {
				type: String,
				default: null
			},
			pageTitleOrgin: {
				type: String,
				default: null
			}
		},
	emits: [ 'menu-toggle'],
	setup(props){	
		onMounted(() => {
			title.value  = "메인화면";
			systemService.getSpringProfileActive().then(data => {
				activeprofile.value = data;
			});
        })		
		const title = ref(props.pageTitle);
		const titleOrigin = ref(props.pageTitleOrgin);
		const activeprofile = ref(); // spring.profiles.active
		const subTitle = ref();
		const home = ref({icon: 'pi pi-home', to: '/MainPage'});
		const items = ref([]);
		const router = useRouter();
		const route = useRoute();
		const store = useStore(); // vuex4에서 사용하는 새로운 방법
		const toast = useToast();
		const authService= new AuthService();
		const systemService = new SystemService();

		const logonUserInfo = computed(() => {
			let _userInfo = "접속자 : ";
			var user = store.state.auth.user;
			if(user == null) {
				user = JSON.parse(localStorage.getItem("user"));
			}

			if(user != null) {
				_userInfo += user.username;
				_userInfo += ' (';
				_userInfo += user.fullNm;
				if(user.custNm != null) {
					_userInfo += ' / ';
					_userInfo += user.custNm;
				}
				_userInfo += ' / ';
				_userInfo += user.userGbNm;
				_userInfo += ')';
			}
			return _userInfo;
		});

		const btnAct = (_act) => {
			switch(_act)
			{
				case "MYINFO":
					router.push({name: 'AccountPage', params: {}});  // 개인정보 변경 페이지로 이동한다
					break;
				case "PASSWORD":
					router.push({name: 'PasswordPage', params: {}});  // 암호변경 페이지로 이동한다
					break;	
				case "LOGOUT":
					var loginuser = JSON.parse(localStorage.getItem("user"));   // sessionStorage는 페이지 세션이 끝날때 제거된다
					if(loginuser == null || loginuser.username == null) {
						return;
					}
					var user = {username: loginuser.username};

					authService.logout(user).then(response => {
						if(response.status) {
							// 로그아웃 성공 시
							router.push({name: 'root', params: {}});  // 최초 페이지로 이동한다
						}
					})
					.catch(error => {
						if (error.response) {
							// The request was made and the server responded with a status code
							toast.add({severity:'error', summary: '로그아웃 오류[2]', detail: error.response.data.message, life: 3000});
						} else if (error.request) {
							// The request was made but no response was received
							// `error.request` is an instance of XMLHttpRequest in the browser and an instance of
							// http.ClientRequest in node.js
							toast.add({severity:'error', summary: '로그아웃 오류[3]', detail: error.request.data, life: 3000});	
						} else {
							// Something happened in setting up the request that triggered an Error
							toast.add({severity:'error', summary: '로그아웃 오류[4]', detail: error.message, life: 3000});	
						}
					});
					break;
				default:
					break;
			}
		}

		watch( 
			() => props.pageTitle, 
			(meta) => {
				title.value = meta;
			},
			() => props.pageTitleOrgin, 
			(meta) => {
				titleOrigin.value = meta;
			}
		)

		watch( 
			() => route.meta, 
			(meta) => {
					if(meta.title)
					{
						title.value = meta.title;
						titleOrigin.value = meta.titleOrigin;
						subTitle.value = meta.subTitle;

						var found = items.value.find(element => element.label == meta.title);
						if(found )
						{
							items.value = items.value.filter(e=>e.label != meta.title)
							items.value.push({label:meta.title})
						}else{
							if(items.length>=3)
							{
								items.value.shift()
								items.value[2]={label:meta.title}
							}
							else{
								items.value.push({label:meta.title})
							}
						}

					}
					else{
						title.value  = "";
						titleOrigin.value = "";
						subTitle.value = "";
					}					
			}
		)

		return {
			title, subTitle, home, items, logonUserInfo, activeprofile, titleOrigin,
			btnAct
		}
	}
}
</script>

<style scoped>
.layout-topbar-title{
	position: relative;
	top: -8px;
	left: 20px;
	display: inline-block;
}
.layout-topbar-title .title{
	font-size: 20px;
	vertical-align: middle;
	font-family: 'NotoSansKR-Bold';
}

div.layout-topbar-breadcrumb{
	float: right;
	position: relative;
	top: -13px;

}
nav.p-breadcrumb.p-component{
	background-color: unset;
	border: 0ch;
	position: relative;
	float: right;
	margin: 0px;
	display: grid; 
	color: white ;
}
</style>